module.exports = __webpack_public_path__ + "static/SO_AMBITIOUS-d89663beb100715334738a278dd46963.jpg";